import * as types from './actionTypes';
import { storageKeys } from '../constants/storageKeys';

const initialState = {
  viewer: null,
  viewerLastUpdated: Date.now(),
  isLoading: {
    assistant: false,
    user: false,
    checkerManager: false,
    recorder: false
  },
  isViewerLoading: false,
  transcript: '',
  typePlaceholder: "Type a message ...",
  messages: [],
  history: {
    entries: [],
    pointer: 0,
  },
  // Holds the JSON BPMN after being edited in the xml transformation pipeline
  processedJson: null,
  checkers: JSON.parse(localStorage.getItem(storageKeys.CHECKERS)) || [],
  // checkers: [
  //     {
  //         "name": "Collaboration Checker",
  //         "description": "Validates BPMN Message Flow",
  //         "endpoint": "https://bpmnchatbot.aau.at/s3/validate",
  //         "selected": true
  //     },
  //     {
  //         "name": "Data Flow Checker",
  //         "description": "Validates BPMN Model with vPAV",
  //         "endpoint": "https://bpmnchatbot.aau.at/vpav/validate",
  //         "selected": true
  //     }
  // ],
};



const reducer = (state = initialState, action) => {
  switch (action.type) {

    case types.RESET_STATE:
      return {
        ...initialState,
        viewer: state.viewer,
        viewerLastUpdated: Date.now(),
        checkers: state.checkers, // <-- Preserve current checkers
      };    
    case types.SET_VIEWER:
      return { 
        ...state,
        viewer: action.viewer,
        viewerLastUpdated: Date.now(),
      };
    case types.ADD_MESSAGE:
      return { 
        ...state, 
        messages: [action.message, ...state.messages] 
      };   
    case types.SET_TRANSCRIPT:
      return { 
        ...state, 
        transcript: action.transcript, 
        typePlaceholder: "Type a message ...",
      };
    

    case types.TOGGLE_LOADER: {
      const { loaderType, isLoading } = action.payload;

      // Set the specific loader explicitly if isLoading provided, otherwise toggle
      const newLoadingState = {
        ...state.isLoading,
        [loaderType]: typeof isLoading === 'boolean' ? isLoading : !state.isLoading[loaderType],
      };
    
      // Determine the new typePlaceholder
      let typePlaceholder;
      if (newLoadingState.recorder) {
        typePlaceholder = "Recording...";
      } else if (Object.values(newLoadingState).some(val => val)) {
        typePlaceholder = ""; // If any loader (assistant, user, checkerManager) is true, set to ""
      } else {
        typePlaceholder = "Type a message ..."; // Otherwise, set to "Type a message ..."
      }
    
      return {
        ...state,
        isLoading: newLoadingState, // Update the state with the new loading state
        typePlaceholder: typePlaceholder, // Set the new placeholder text
      };
    }
    case types.SET_VIEWER_LOADING:
      return {
        ...state,
        isViewerLoading: action.payload,
      };
    case types.ABORT_ALL_LOADERS:
      return {
        ...state,
        isLoading: Object.keys(state.isLoading).reduce((acc, key) => {
          acc[key] = false;
          return acc;
        }, {}),
      };
    case types.ADD_HISTORY_ENTRY:
      return {
        ...state,
        history: {
          entries: [...state.history.entries, action.entry],
          pointer: state.history.entries.length,
        }
      };
    case types.INCREASE_HISTORY_POINTER:
      return {
        ...state,
        history: {
          ...state.history,
          pointer: Math.min(state.history.pointer + 1, state.history.entries.length - 1),
        },
      };
    case types.DECREASE_HISTORY_POINTER:
      return {
        ...state,
        history: {
          ...state.history,
          pointer: Math.max(state.history.pointer - 1, 0),
        },
      };
    case types.SET_HISTORY_POINTER:
      return {
        ...state,
        history: {
          ...state.history,
          pointer: action.pointer,
        },
      };

    case types.SET_CURRENT_JSONBPMN:
      return {
        ...state,
        processedJson: action.processedJson,
      };


    case types.SET_CHECKERS: {
        const updatedCheckers = action.payload;
        return { ...state, checkers: updatedCheckers };
      }
  
    case types.TOGGLE_CHECKER_SELECTION: {
        const updatedCheckers = state.checkers.map((checker) =>
          checker.id === action.payload
            ? { ...checker, selected: !checker.selected }
            : checker
        );
        return { ...state, checkers: updatedCheckers };
      }
   
    default:
      return state;
  }

};

export default reducer;
